import React, {useContext} from 'react';
import {TagContext, TagProvider} from "../../context/tagContext";
import Body from "../common/Body";
import {Helmet} from "react-helmet";
import {generateHeadTags} from "react-seo-tools";
import ResultSection from "./section/ResultSection";
import {WidgetContext} from "../../context/widgetContext";
import HtmlParsedText from "../common/HtmlParsedText";

const SidebarContent = () => {
	const {
		forum_overview_members_online,
		forum_overview_new_posts,
		forum_overview_forum_statistics,
		tag_cloud,
		fetchWidgetHtml
	} = useContext(WidgetContext);

	fetchWidgetHtml('forum_overview_members_online');
	fetchWidgetHtml('forum_overview_new_posts');
	fetchWidgetHtml('forum_overview_forum_statistics');
	fetchWidgetHtml('tag_cloud');

	return (
		<>
			<div className="mb-4">
				{forum_overview_members_online && (<HtmlParsedText text={forum_overview_members_online}/>)}
			</div>

			<div className="mb-4">
				{forum_overview_new_posts && (<HtmlParsedText text={forum_overview_new_posts}/>)}
			</div>

			<div className="mb-4">
				{forum_overview_forum_statistics && (<HtmlParsedText text={forum_overview_forum_statistics}/>)}
			</div>

			<div className="mb-4">
				{tag_cloud && (<HtmlParsedText text={tag_cloud}/>)}
			</div>
		</>
	);
}

const HeroContent = () => {
	const {tag} = useContext(TagContext);

	if (tag) {
		return (
			<div className="px-2 pt-2 md:px-4 md:pt-4">
				<div className="flex items-center text-white mb-2">
					<div>
						<h1 className="text-lg font-medium">
							{tag.tag}
						</h1>
					</div>
				</div>
			</div>
		)
	}
}

const MainContent = () => {
	const {tag} = useContext(TagContext);

	return (
		<div>
			{tag && (
				<Helmet>
					{generateHeadTags({
						title: tag.tag,
						description: '',
						openGraph: {
							type: 'website',
							title: tag.tag,
							image: '',
						},
					})}
				</Helmet>
			)}

			{tag && (
				<div>
					<section className="mb-4">
						<ResultSection />
					</section>
				</div>
			)}
		</div>
	);
}

const Tag = () => {
	return (
		<TagProvider>
			<Body heroContent={<HeroContent />} mainContent={<MainContent/>} sidebarContent={<SidebarContent />} />
		</TagProvider>
	)
}

export default Tag;